// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__15PLh","rootMobile":"styles_rootMobile__AA38-"};